import React, { CSSProperties } from "react";

/**
 * 核心亚克力基础样式
 * 移除了 @material-ui/core/styles 的依赖，使用标准 CSSProperties
 */
const acrylicBaseStyle: CSSProperties = {
  backdropFilter: "blur(30px) brightness(80%) saturate(160%)",
  WebkitBackdropFilter: "blur(30px) brightness(80%) saturate(160%)", // 兼容 Safari
};

// --- 帮助函数：深度合并样式 ---
const mergeStyles = (
  ...styles: (CSSProperties | undefined)[]
): CSSProperties => {
  return Object.assign({}, ...styles);
};

/**
 * AcrylicAlert
 * 模拟原先 Alert 的不同颜色状态
 */
export const AcrylicAlert = ({
  severity = "info",
  style,
  children,
  onClose,
  ...props
}: any) => {
  const severityColors: Record<string, string> = {
    error: "rgba(244, 67, 54, .4)",
    warning: "rgba(255, 152, 0, .4)",
    info: "rgba(33, 150, 243, .4)",
    success: "rgba(76, 175, 80, .4)",
  };

  const alertStyle = mergeStyles(
    acrylicBaseStyle,
    {
      backgroundColor: severityColors[severity] || severityColors.info,
      padding: "12px 16px",
      borderRadius: "4px",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    },
    style,
  );

  return (
    <div style={alertStyle} {...props}>
      <div>{children}</div>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "#fff",
            cursor: "pointer",
            fontSize: "18px",
            marginLeft: "12px",
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

/**
 * AcrylicTooltip
 * 包装子组件并显示一个亚克力浮层
 */
export const AcrylicTooltip = ({ title, open, children, style }: any) => {
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {children}
      {open && (
        <div
          style={mergeStyles(
            acrylicBaseStyle,
            {
              position: "absolute",
              bottom: "100%",
              left: "50%",
              transform: "translateX(-50%) translateY(-8px)",
              backgroundColor: "rgba(97, 97, 97, 0.5)",
              color: "#fff",
              padding: "4px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              whiteSpace: "nowrap",
              zIndex: 100,
              pointerEvents: "none",
            },
            style,
          )}
        >
          {title}
        </div>
      )}
    </div>
  );
};

/**
 * 通用亚克力容器 (用于 Popover, Menu, Dialog)
 */
const AcrylicPaper = ({ children, style, open, onClose }: any) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={mergeStyles(
          acrylicBaseStyle,
          {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            borderRadius: "8px",
            minWidth: "200px",
            overflow: "hidden",
          },
          style,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export const AcrylicPopover = AcrylicPaper;
export const AcrylicMenu = AcrylicPaper;
export const AcrylicDialog = AcrylicPaper;
